import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAircallIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.604.559C18.135.221 15.73 0 13 0S7.865.221 6.396.559A7.55 7.55 0 0 0 .559 6.396C.221 7.865 0 10.27 0 13s.221 5.135.559 6.604a7.55 7.55 0 0 0 5.837 5.837C7.865 25.779 10.27 26 13 26s5.135-.221 6.604-.559a7.55 7.55 0 0 0 5.837-5.837C25.779 18.135 26 15.73 26 13s-.221-5.135-.559-6.604A7.55 7.55 0 0 0 19.604.559",
		fill: "#00b388"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.121 19.955a1.95 1.95 0 0 0-1.404-1.157c-.377-.091-1.014-.143-1.716-.143s-1.339.052-1.716.143a1.95 1.95 0 0 0-1.404 1.157.49.49 0 0 1-.507.299c-.052 0-.104-.013-.143-.013-1.014-.104-1.82-.247-2.288-.403a.82.82 0 0 1-.533-.767v-.104c.078-1.066.728-3.549 1.69-6.383 1.105-3.237 2.25-5.863 2.77-6.383a.9.9 0 0 1 .285-.208.4.4 0 0 1 .156-.065c.338-.117.975-.195 1.69-.195s1.352.078 1.69.195c.065.026.117.039.156.065.104.052.195.13.286.208.52.507 1.664 3.133 2.77 6.383.961 2.834 1.611 5.317 1.69 6.383v.104a.82.82 0 0 1-.534.767c-.468.169-1.26.312-2.288.403-.039 0-.104.013-.156.013a.51.51 0 0 1-.494-.299",
		fill: "#fff"
	})]
});
export default SvgAircallIcon;
